import styled from "styled-components";
import { useState, useContext, useEffect, createContext, useRef } from "react";
import { listenToUserDatabase, listenToSelectUserDatabase } from "../Firebase";
import {
  createNodesFromUserRoles,
  getAllTeamIdsFromOrgTreeArray,
} from "../Helpers/OrgTreeFunctions";
import { CurrentUserContext } from "./CurrentUserContext";
import { OrgTreeContext } from "./OrgTreeContext";

interface UsersContext {
  usersDatabase: UserData[] | null;
  setUsersNeeded: React.Dispatch<React.SetStateAction<string[] | null>>;
}

export const UsersDatabaseContext = createContext<UsersContext>({
  usersDatabase: null,
  setUsersNeeded: () => {},
});

export default function UserDatabaseContextProvider(props: Props) {
  const userContext = useContext(CurrentUserContext);
  const [usersDatabase, setUsersDatabase] = useState<UserData[] | null>(null);
  const [usersNeeded, setUsersNeeded] = useState<string[] | null>(null);
  const unsubscribeFunctions = useRef<(() => void)[]>([]); // useRef to keep track of unsubscribe functions

  useEffect(() => {
    if (!userContext?.currentFirebaseUser) return;

    if (!usersNeeded) return;

    const unsubscribeFromNewUsers = listenToSelectUserDatabase(
      usersNeeded,
      (data) => {
        data && setUsersDatabase(data);
      }
    );
    // Add new unsubscribe functions to the existing array
    unsubscribeFunctions.current.push(unsubscribeFromNewUsers);

  }, [userContext, usersNeeded]);

  useEffect(() => {
    // Cleanup: Unsubscribe from all listeners when the component unmounts
    return () => {
      unsubscribeFunctions.current.forEach((unsubscribe) => unsubscribe());
    };
  }, []);

/*   useEffect(() => {
    console.log("UsersDatabaseContextProvider: usersDatabase", usersDatabase);
  }, [usersDatabase]); */

  return (
    <UsersDatabaseContext.Provider value={{ usersDatabase, setUsersNeeded }}>
      {props.children}
    </UsersDatabaseContext.Provider>
  );
}

interface Props {
  children: React.ReactNode;
}
